import Grid from '@mui/material/Grid'
import LinearProgress from '@mui/material/LinearProgress'
import clsx from 'clsx'
import Image from 'next/image'

import { brandLogoPath, brandLogoAlt, calculateWidthByBrand } from '@src/utils'

import styles from './styles.module.scss'

export const SplashOverlay = ({
  fixed = false,
}: {
  /** If true, the splash overlay will be fixed to the top of the screen and take precedence over other content. */
  fixed?: boolean
}) => {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      direction="column"
      className={clsx(styles['container'], fixed && styles['fixed'])}
    >
      <Grid item>
        <div className="mb-5">
          <Image
            src={brandLogoPath}
            alt={brandLogoAlt}
            width={calculateWidthByBrand(120)}
            height={19}
          />
        </div>
      </Grid>
      <Grid item>
        <div className="progress-bar">
          <LinearProgress />
        </div>
      </Grid>
    </Grid>
  )
}
